import { useMemo } from "react";

import { OptionType, useGetOptionsQuery } from "@/api/admin";

import {
  type CollectionHistoryOptions,
  createCollectionHistoryResolvers,
} from "../utils/formatCollectionHistory";
import { MEDIA_URL_FIELD_RESOLVER } from "../utils/mediaUrlResolver";

export const useCollectionHistoryResolvers = () => {
  const { data } = useGetOptionsQuery([
    OptionType.Ambiance,
    OptionType.Cuisines,
    OptionType.Moment,
  ]);

  const options: CollectionHistoryOptions = useMemo(
    () => ({
      ambiance: data?.ambiance,
      cuisines: data?.cuisines,
      moment: data?.moment,
    }),
    [data?.ambiance, data?.cuisines, data?.moment]
  );

  return useMemo(
    () => ({
      ...createCollectionHistoryResolvers(options),
      mediaItem: MEDIA_URL_FIELD_RESOLVER,
    }),
    [options]
  );
};
